import { MNSproCloudApi } from '..';
import { removeServiceUserFromWorkgroupMembers } from '../../utils/serviceUserUtils';
import { Workgroup, WorkgroupDriveItem, WorkgroupMember } from '../api/v2';

const getWorkgroupApi = (token: string) =>
  MNSproCloudApi.V2.WorkgroupsApiFactory(
    MNSproCloudApi.V2.createConfiguration(token),
  );

export class WorkgroupService {
  static async getWorkgroup(
    authToken: string,
    organizationId: string,
    groupId: string,
  ): Promise<Workgroup> {
    const api = getWorkgroupApi(authToken);
    const result = await api.get(groupId, organizationId);
    return result.data;
  }

  static async getAllWorkgroups(
    authToken: string,
    organizationId: string,
  ): Promise<Workgroup[]> {
    const api = getWorkgroupApi(authToken);
    const result = await api.getAll(organizationId);

    return result.data;
  }

  static async getWorkgroupMaterial(
    authToken: string,
    organizationId: string,
    groupId: string,
  ): Promise<WorkgroupDriveItem> {
    const api = getWorkgroupApi(authToken);
    const result = await api.getMaterial(groupId, organizationId);

    return result.data;
  }

  static async getWorkgroupMembers(
    authToken: string,
    workgroupId: string,
    organizationId: string,
  ): Promise<WorkgroupMember[]> {
    const api = getWorkgroupApi(authToken);
    const members = (await api.getMembers(workgroupId, organizationId)).data;

    return removeServiceUserFromWorkgroupMembers(members);
  }

  static async getWorkgroupOwners(
    authToken: string,
    workgroupId: string,
    organizationId: string,
  ): Promise<WorkgroupMember[]> {
    const api = getWorkgroupApi(authToken);

    const response = await api.getOwners(workgroupId, organizationId);
    return removeServiceUserFromWorkgroupMembers(response.data);
  }

  static async addUsersToWorkgroup(
    authToken: string,
    organizationId: string,
    workgroupId: string,
    userIds: string[],
  ): Promise<void> {
    const api = getWorkgroupApi(authToken);
    await api.addMembers(workgroupId, organizationId, userIds);
  }

  static async removeMembersFromWorkgroup(
    authToken: string,
    organizationId: string,
    workgroupId: string,
    userIds: string[],
  ): Promise<void> {
    const api = getWorkgroupApi(authToken);
    await api.removeMembers(workgroupId, organizationId, userIds);
  }
  static async demoteWorkgroupMember(
    authToken: string,
    organizationId: string,
    workgroupId: string,
    userIds: string[],
  ): Promise<void> {
    const api = getWorkgroupApi(authToken);
    await api.demoteMember(organizationId, workgroupId, userIds);
  }
  static async promoteWorkgroupMember(
    authToken: string,
    organizationId: string,
    workgroupId: string,
    userIds: string[],
  ): Promise<void> {
    const api = getWorkgroupApi(authToken);
    await api.promoteMember(organizationId, workgroupId, userIds);
  }

  static async repairWorkgroupTeamOwnerships(
    authToken: string,
    organizationId: string,
    workgroupId: string,
  ): Promise<void> {
    const api = getWorkgroupApi(authToken);
    await api.repairTeamOwnerShip(organizationId, workgroupId);
  }
}
